import React, { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import FeatherIcon from "feather-icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDataContext } from "../../components/context/app-data-context.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import UploadDialogue from "../../components/upload/upload-dialogue";
import { tabselected } from "../../consts.js";
import { CampaignInsightModel } from "../../models/campaign.js";
import { getInsightDataAPI } from "../../services/analytics.js";
import { generateTranscriptAPI } from "../../services/conversation.js";
import CampaignArchive from "./campaign-archived";
import CampaignConversations from "./campaign-conversations";
import CampaignInsights from "./campaign-insights";
import { INSIGHT_PAGE } from "../../helpers/constant.js";
import Loader from "../../components/loader/index.jsx";

function Campaign() {
    const { colours, FONT } = useThemeMode();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [campaignId] = React.useState(params.get("id") || "");
    const AppDataContextDTO = useContext(AppDataContext);

    const [selectedTab, setSelectedTab] = React.useState("Campaign insights");
    const [updated, setUpdated] = React.useState(0);
    const [open, setOpen] = React.useState(false);

    const [spinner, setSpinner] = React.useState(false);
    const [analytics, setAnalytics] = React.useState(new CampaignInsightModel());

    async function getCampaignData() {
        try {
            setSpinner(true);
            const { data } = await getInsightDataAPI({ id: campaignId, type: INSIGHT_PAGE.CAMPAIGN });
            setAnalytics(Object.assign(analytics, data));
            // set data for breadcrumb
            AppDataContextDTO.setCampaign({
                id: data.id,
                name: data.name
            });
            setSpinner(false);
        } catch (error) {
            console.error("Error fetching campaign insights: ", error)
            setSpinner(false);
        }
    }

    React.useEffect(() => {
        AppDataContextDTO.clearAppData();
        if (!campaignId) {
            navigate("/campaigns");
        }
        getCampaignData(); // Your async data fetching function
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [campaignId]);

    const onUpload = (tabName) => {
        setOpen(true); // Open the dialog when the tab is clicked
    };

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            {spinner && <Loader />}
            {/* <Stack gap={1} flexDirection="row" flexWrap="wrap" alignItems="center" sx={{ wordBreak: 'break-word', padding: { xs: "10px 12px", md: "10px 24px" } }}>
                <Stack flexDirection="row" gap={.5}>
                <FeatherIcon icon="award" style={{ flexShrink: 0 }} />
                <Link component="button" underline="none" color="inherit" onClick={returnToCampaigns}>Campaigns /</Link>
                </Stack>
                <Stack flexDirection="row" gap={.5}>
                <FeatherIcon icon="list" style={{ flexShrink: 0 }} />
                <Typography component="div" sx={{ fontWeight: "bolder", borderBottom: "solid 2px" }}>{campaignName}</Typography>
                </Stack>
            </Stack> */}
            <Grid
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                borderBottom={colours.dividergraybottomborder}
                paddingX={1}
                alignItems="center"
            >
                <Typography
                    component="div"
                    display="flex"
                    flexDirection="row"
                    marginRight="auto"
                    alignItems={{ xs: 'end', sm: 'normal' }}
                >
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Campaign insights", colours, FONT)}
                        onClick={() => setSelectedTab("Campaign insights")}
                    >
                        Campaign Insights
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Processed conversations", colours, FONT)}
                        onClick={() => setSelectedTab("Processed conversations")}
                    >
                        Processed Conversations
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Archived", colours, FONT)}
                        onClick={() => setSelectedTab("Archived")}
                    >
                        Archived
                    </Typography>
                </Typography>
                <Typography component="div" sx={{ order: { xs: '-1', sm: '0' }, paddingTop: { xs: 1, sm: 0 }, flexGrow: { xs: 1, sm: 0 } }}>
                    <Button
                        variant="contained"
                        onClick={() => onUpload("Upload Conversation")}
                        startIcon={<FeatherIcon icon="upload" size={20} />}
                        sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                        Upload
                    </Button>
                </Typography>
            </Grid>

            {selectedTab === "Campaign insights" && <CampaignInsights analytics={analytics} />}
            {selectedTab === "Processed conversations" && <CampaignConversations updated={updated} />}
            {selectedTab === "Archived" && <CampaignArchive />}

            {/* Upload Dialogue */}
            <UploadDialogue
                open={open}
                onClose={() => setOpen(false)} // Close the dialog when onClose is triggered
                campaignData={analytics}
                onSuccess={(createdConversationId) => {
                    setUpdated(updated + 1);
                    generateTranscriptAPI(createdConversationId)
                }}
            />
        </Grid>
    );
}

export default Campaign;